var Emitter = (function () {
    function Emitter() {
    }
    Emitter.prototype.on = function (event, listener) {
        this._eventCollection = this._eventCollection || {};
        this._eventCollection[event] = this._eventCollection[event] || [];
        this._eventCollection[event].push(listener);
        return this;
    };
    Emitter.prototype.once = function (event, listener) {
        var self = this;
        function fn() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            self.off(event, fn);
            listener.apply(this, args);
        }
        fn.listener = listener;
        this.on(event, fn);
        return this;
    };
    Emitter.prototype.off = function (event, listener) {
        var listeners;
        if (!this._eventCollection || !(listeners = this._eventCollection[event])) {
            return this;
        }
        listeners.forEach(function (fn, i) {
            if (fn === listener || fn.listener === listener) {
                listeners.splice(i, 1);
            }
        });
        if (listeners.length === 0) {
            delete this._eventCollection[event];
        }
        return this;
    };
    Emitter.prototype.emit = function (event) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listeners;
        if (!this._eventCollection || !(listeners = this._eventCollection[event])) {
            return this;
        }
        listeners = listeners.slice(0);
        listeners.forEach(function (fn) { return fn.apply(_this, args); });
        return this;
    };
    return Emitter;
}());
export default Emitter;
